
var id = "greyTriangle";
var markup = "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"greyTriangle\">\n    <title></title>\n    <defs>\n        <path d=\"M6.66666667,5.66666667 L8,5.66666667 L8,4.66666667 L9,4.66666667 L7.33333333,3 L5.66666667,4.66666667 L6.66666667,4.66666667 L6.66666667,5.66666667 Z M5.66666667,6.66666667 L4.66666667,6.66666667 L4.66666667,5.66666667 L3,7.33333333 L4.66666667,9 L4.66666667,8 L5.66666667,8 L5.66666667,6.66666667 Z M11.6666667,7.33333333 L10,5.66666667 L10,6.66666667 L9,6.66666667 L9,8 L10,8 L10,9 L11.6666667,7.33333333 Z M8,9 L6.66666667,9 L6.66666667,10 L5.66666667,10 L7.33333333,11.6666667 L9,10 L8,10 L8,9 Z\" id=\"greyTriangle_path-1\" />\n    </defs>\n    <g id=\"greyTriangle_营销活动（fa）\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"greyTriangle_icon-灰色\">\n            <path d=\"M22.7928932,0.5 L0.5,22.7928932 L0.5,6 C0.5,4.48121694 1.11560847,3.10621694 2.1109127,2.1109127 C3.10621694,1.11560847 4.48121694,0.5 6,0.5 L6,0.5 L22.7928932,0.5 Z\" id=\"greyTriangle_矩形\" stroke=\"#616161\" fill=\"#D8D8D8\" />\n            <mask id=\"greyTriangle_mask-2\" fill=\"white\">\n                <use xlink:href=\"#greyTriangle_path-1\" />\n            </mask>\n            <use id=\"greyTriangle_icon/action/open_with_24px\" fill=\"#616161\" xlink:href=\"#greyTriangle_path-1\" />\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
